export const isPathActive = ({
  exact = false,
  pathname,
  to,
}: {
  exact?: boolean;
  pathname: string;
  to: string;
}) =>
  exact ? pathname === to : pathname === to || pathname.startsWith(`${to}/`);
